// This file is automatically generated. Do not edit manually.

import { CustomerOfferPartCostView } from "src/api/generated/erp/db/types/tables/customerOfferPartCostView";
import { PartView } from "src/api/generated/erp/db/types/tables/partView";
import { PartCostOverrideOptionsProvider_PropertyValueOption } from "src/api/generated/erp/sales/partCostOverride/partCostOverrideOptionsProvider";
import { PartCostOverrideConditions } from "src/api/generated/io/aavo/applications/db/erp/types/partCostOverrideConditions";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CustomerOfferPartCostOverrideApi {
	export async function getPartCostOverrides(args: {
		customerOrderOfferId: number;
	}): Promise<Array<CustomerOfferPartCostView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderOffer/partCostOverrides/getPartCostOverrides",
			method: "POST",
			data: {
				customerOrderOfferId: args.customerOrderOfferId,
			},
		});
		return response as Array<CustomerOfferPartCostView>;
	}

	export async function getPartOptions(args: { customerOrderOfferId: number }): Promise<Array<PartView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderOffer/partCostOverrides/getPartOptions",
			method: "POST",
			data: {
				customerOrderOfferId: args.customerOrderOfferId,
			},
		});
		return response as Array<PartView>;
	}

	export async function getPropertyValueOptions(args: {
		customerOrderOfferId: number;
		partId: number;
	}): Promise<Array<PartCostOverrideOptionsProvider_PropertyValueOption>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderOffer/partCostOverrides/getPropertyValueOptions",
			method: "POST",
			data: {
				customerOrderOfferId: args.customerOrderOfferId,
				partId: args.partId,
			},
		});
		return response as Array<PartCostOverrideOptionsProvider_PropertyValueOption>;
	}

	export async function createPartCostOverride(args: {
		customerOrderOfferId: number;
		partId: number;
		propertyConditions: PartCostOverrideConditions;
		unitCost: number;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderOffer/partCostOverrides/createPartCostOverride",
			method: "POST",
			data: {
				customerOrderOfferId: args.customerOrderOfferId,
				partId: args.partId,
				propertyConditions: args.propertyConditions,
				unitCost: args.unitCost,
			},
		});
		return response as void;
	}

	export async function updatePartCostOverride(args: {
		customerOrderOfferId: number;
		customerOfferPartCostId: number;
		partId: number;
		propertyConditions: PartCostOverrideConditions;
		unitCost: number;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderOffer/partCostOverrides/updatePartCostOverride",
			method: "POST",
			data: {
				customerOrderOfferId: args.customerOrderOfferId,
				customerOfferPartCostId: args.customerOfferPartCostId,
				partId: args.partId,
				propertyConditions: args.propertyConditions,
				unitCost: args.unitCost,
			},
		});
		return response as void;
	}

	export async function deletePartCostOverride(args: {
		customerOrderOfferId: number;
		customerOfferPartCostId: number;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderOffer/partCostOverrides/deletePartCostOverride",
			method: "POST",
			data: {
				customerOrderOfferId: args.customerOrderOfferId,
				customerOfferPartCostId: args.customerOfferPartCostId,
			},
		});
		return response as void;
	}
}
